import { render } from "./About.vue?vue&type=template&id=1c06f6fc"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__